import React from 'react';

export const Navigation = ({ nav, label, id }) => {
    return (
        <div className="p10 text-center" style={{ borderBottom: 'solid 1px #f4f4f4' }}>
            <button className="btn btn-xs" onClick={() => nav(-1)} data-testid={`widget-nav-prev-${id}`}>
                <i className="fa fa-arrow-left" />
            </button>
            <span className="mr10 ml10">{label}</span>
            <button className="btn btn-xs" onClick={() => nav(1)} data-testid={`widget-nav-next-${id}`}>
                <i className="fa fa-arrow-right" />
            </button>
        </div>
    );
};

export default Navigation;
